import React from 'react';
import { Box, Loader, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ShowHide } from '@bcp-channels-sharedcomponents-reactjs/core';

export const GLOBAL_LOADER = 'loaders.global';

export const GlobalLoader: React.FC = () => {
	const { palette } = useTheme();

	return (
		<ShowHide name={GLOBAL_LOADER}>
			<Box
				styles={{
					position: 'absolute',
					width: '100%',
					height: '100%',
					justifyContent: 'center',
					zIndex: 9999,
					display: 'flex',
					background: palette.global.ui18,
				}}
			>
				<Loader width={150} height={150} />
			</Box>
		</ShowHide>
	);
};
